import { render, staticRenderFns } from "./HeatmapSorter.vue?vue&type=template&id=6ecd66a0"
import script from "./HeatmapSorter.vue?vue&type=script&lang=js"
export * from "./HeatmapSorter.vue?vue&type=script&lang=js"
import style0 from "./HeatmapSorter.vue?vue&type=style&index=0&id=6ecd66a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports